import { EmbedFigmaBlockComponent } from './embed-figma-block';
import { EmbedEdgelessBlockComponent } from './embed-figma-block/embed-edgeless-figma-block';
import { EmbedGithubBlockComponent } from './embed-github-block';
import { EmbedEdgelessGithubBlockComponent } from './embed-github-block/embed-edgeless-github-block';
import { EmbedHtmlBlockComponent } from './embed-html-block';
import { EmbedHtmlFullscreenToolbar } from './embed-html-block/components/fullscreen-toolbar';
import { EmbedEdgelessHtmlBlockComponent } from './embed-html-block/embed-edgeless-html-block';
import { EmbedIframeErrorCard } from './embed-iframe-block/components/embed-iframe-error-card';
import { EmbedIframeIdleCard } from './embed-iframe-block/components/embed-iframe-idle-card';
import { EmbedIframeLinkEditPopup } from './embed-iframe-block/components/embed-iframe-link-edit-popup';
import { EmbedIframeLinkInputPopup } from './embed-iframe-block/components/embed-iframe-link-input-popup';
import { EmbedIframeLoadingCard } from './embed-iframe-block/components/embed-iframe-loading-card';
import { EmbedEdgelessIframeBlockComponent } from './embed-iframe-block/embed-edgeless-iframe-block';
import { EmbedIframeBlockComponent } from './embed-iframe-block/embed-iframe-block';
import { EmbedLinkedDocBlockComponent } from './embed-linked-doc-block';
import { EmbedEdgelessLinkedDocBlockComponent } from './embed-linked-doc-block/embed-edgeless-linked-doc-block';
import { EmbedLoomBlockComponent } from './embed-loom-block';
import { EmbedEdgelessLoomBlockComponent } from './embed-loom-block/embed-edgeless-loom-bock';
import { EmbedSyncedDocBlockComponent } from './embed-synced-doc-block';
import { EmbedSyncedDocCard } from './embed-synced-doc-block/components/embed-synced-doc-card';
import { EmbedEdgelessSyncedDocBlockComponent } from './embed-synced-doc-block/embed-edgeless-synced-doc-block';
import { EmbedYoutubeBlockComponent } from './embed-youtube-block';
import { EmbedEdgelessYoutubeBlockComponent } from './embed-youtube-block/embed-edgeless-youtube-block';

export function effects() {
  customElements.define(
    'hive-embed-edgeless-figma-block',
    EmbedEdgelessBlockComponent
  );
  customElements.define('hive-embed-figma-block', EmbedFigmaBlockComponent);

  customElements.define('hive-embed-html-block', EmbedHtmlBlockComponent);
  customElements.define(
    'hive-embed-edgeless-html-block',
    EmbedEdgelessHtmlBlockComponent
  );

  customElements.define(
    'embed-html-fullscreen-toolbar',
    EmbedHtmlFullscreenToolbar
  );
  customElements.define(
    'hive-embed-edgeless-github-block',
    EmbedEdgelessGithubBlockComponent
  );
  customElements.define('hive-embed-github-block', EmbedGithubBlockComponent);

  customElements.define(
    'hive-embed-edgeless-youtube-block',
    EmbedEdgelessYoutubeBlockComponent
  );
  customElements.define(
    'hive-embed-youtube-block',
    EmbedYoutubeBlockComponent
  );

  customElements.define(
    'hive-embed-edgeless-loom-block',
    EmbedEdgelessLoomBlockComponent
  );
  customElements.define('hive-embed-loom-block', EmbedLoomBlockComponent);

  customElements.define('hive-embed-synced-doc-card', EmbedSyncedDocCard);

  customElements.define(
    'hive-embed-edgeless-linked-doc-block',
    EmbedEdgelessLinkedDocBlockComponent
  );
  customElements.define(
    'hive-embed-linked-doc-block',
    EmbedLinkedDocBlockComponent
  );

  customElements.define(
    'hive-embed-edgeless-synced-doc-block',
    EmbedEdgelessSyncedDocBlockComponent
  );
  customElements.define(
    'hive-embed-synced-doc-block',
    EmbedSyncedDocBlockComponent
  );

  customElements.define(
    'hive-embed-edgeless-iframe-block',
    EmbedEdgelessIframeBlockComponent
  );
  customElements.define('hive-embed-iframe-block', EmbedIframeBlockComponent);
  customElements.define(
    'embed-iframe-link-input-popup',
    EmbedIframeLinkInputPopup
  );
  customElements.define('embed-iframe-loading-card', EmbedIframeLoadingCard);
  customElements.define('embed-iframe-error-card', EmbedIframeErrorCard);
  customElements.define('embed-iframe-idle-card', EmbedIframeIdleCard);
  customElements.define(
    'embed-iframe-link-edit-popup',
    EmbedIframeLinkEditPopup
  );
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-embed-figma-block': EmbedFigmaBlockComponent;
    'hive-embed-edgeless-figma-block': EmbedEdgelessBlockComponent;
    'hive-embed-github-block': EmbedGithubBlockComponent;
    'hive-embed-edgeless-github-block': EmbedEdgelessGithubBlockComponent;
    'hive-embed-html-block': EmbedHtmlBlockComponent;
    'hive-embed-edgeless-html-block': EmbedEdgelessHtmlBlockComponent;
    'embed-html-fullscreen-toolbar': EmbedHtmlFullscreenToolbar;
    'hive-embed-edgeless-loom-block': EmbedEdgelessLoomBlockComponent;
    'hive-embed-loom-block': EmbedLoomBlockComponent;
    'hive-embed-youtube-block': EmbedYoutubeBlockComponent;
    'hive-embed-edgeless-youtube-block': EmbedEdgelessYoutubeBlockComponent;
    'hive-embed-synced-doc-card': EmbedSyncedDocCard;
    'hive-embed-synced-doc-block': EmbedSyncedDocBlockComponent;
    'hive-embed-edgeless-synced-doc-block': EmbedEdgelessSyncedDocBlockComponent;
    'hive-embed-linked-doc-block': EmbedLinkedDocBlockComponent;
    'hive-embed-edgeless-linked-doc-block': EmbedEdgelessLinkedDocBlockComponent;
    'hive-embed-iframe-block': EmbedIframeBlockComponent;
    'embed-iframe-link-input-popup': EmbedIframeLinkInputPopup;
    'embed-iframe-loading-card': EmbedIframeLoadingCard;
    'embed-iframe-error-card': EmbedIframeErrorCard;
    'embed-iframe-idle-card': EmbedIframeIdleCard;
    'embed-iframe-link-edit-popup': EmbedIframeLinkEditPopup;
  }
}
